/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import React from 'react';
import './Modal.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Carousel from 'react-bootstrap/Carousel';
import Modal from 'react-bootstrap/Modal';
export default function ModalFR({ showModal, handleClose }) {


return (
        <React.Fragment>
    <Modal show={showModal?.initiative === true} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>À propos du projet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Mon objectif est de partager mon réseau, et de l’étendre dans le canton du Valais où je me suis récemment installé et ai reçu un accueil chaleureux.
            <br /><br />
            Je ne souhaite pas remplacer les projets existants, mais les compléter en apportant des idées et des personnes innovantes.
            <br /><br />
            Le but principal est d’inviter les innovateurs à créer, développer et industrialiser leur projet dans le canton du Valais, en coordination avec des partenaires locaux, des écoles et des centres de recherche. Chacun peut apporter son expertise : aider à la relocalisation, être une personne de confiance impliquée dans le projet, ou un sous-traitant. Tous doivent avoir établi une relation de confiance avec l’équipe. Cet état d’esprit crée une atmosphère propice à l’investissement.
            <br /><br />
            Es-tu innovateur&nbsp;? Investisseur&nbsp;? Fournisseur de services utiles&nbsp;? Souhaites-tu devenir un partenaire clé du réseau&nbsp;? Alors contacte-nous.
            <br/><br/>
            <div className="card-centered">
                <Card className="card-content">
                <div className="card-text">
                    <p>Rejoins le creuset de l'innovation</p>
                    <p>Une initiative portée par myBusinessPartner</p>
                    <p>c/o OnSite-Consulting Sàrl</p>
                    <p>Ch. du Mâcheret 29</p>
                    <p>1039 La Conversion</p>
                </div>
                </Card>
            </div>
            <p className="center">
                Innoves-a-sion ™ est une marque déposée<br />
                par OnSite-Consulting Sàrl<br/>
                mais tu peux venir innover partout en Valais.
            </p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Fermer
            </Button>
        </Modal.Footer>
    </Modal>

    <Modal show={showModal?.invest === true} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Au sommet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div>
                Au sommet des vallées, nous avons de nombreux villages exquis comme Verbier, Crans-Montana, Saas-Fee et Zermatt.<br/> 
                <br/>
                Ce sont quatre stations de ski ensoleillées, pour s’amuser en hiver, mais aussi pour des événements et spectacles tout au long de l’année organisés par des équipes touristiques passionnées&nbsp;!
                <br/><br/>
                Ici, vous trouverez de nouveaux atouts, mais pas seulement&nbsp;: vous profiterez aussi de l’air frais, vivrez dans une atmosphère paisible et ferez de bonnes affaires.
                <br/><br/>
                Un bon choix de vie est de venir travailler avec nous.
            </div>        
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Fermer
            </Button>
        </Modal.Footer>
    </Modal>

    <Modal show={showModal?.vivre === true} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Niveau de vie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Le canton du Valais offre une excellente qualité de vie, les impôts ne sont pas élevés,
            nous avons des autorités efficaces ainsi que d’excellents services publics. Les loyers
            et le coût de la vie en général sont bas. Le canton du Valais est connu pour être
            le canton le plus ensoleillé de Suisse.
            <br/><br/>
            Travailler et vivre en Valais est synonyme d’une vie meilleure.
            <br/><br/>
            Vous pouvez trouver des fruits et légumes biologiques locaux. Situé au cœur de
            l’Europe, nous avons des connexions directes par les transports publics vers Milan, Paris
            et de nombreuses grandes villes allemandes.
            Le canton possède son propre aéroport, mais il existe aussi des connexions directes avec
            les deux principaux hubs suisses (les aéroports de Genève et Zurich) à moins de
            deux heures.

            <hr/>

            <h2 className="center">
                Nous avons presque tout<br/>
                Le seul joyau qui manque, c’est 
                <br/>
                VOUS 
                <br/><br/>
            </h2>
            <h2 className="center">
                Rejoignez-nous.
            </h2>
            <hr/>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Fermer
            </Button>
        </Modal.Footer>
    </Modal>


    <Modal show={showModal?.loisirs === true} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Loisirs et détente</Modal.Title>
        </Modal.Header>
        <Modal.Body>

            Lorsque vous travaillez dur, vous devez prendre le temps de vous détendre. Cette région offre
            presque tout pour profiter d’un moment de relaxation.
            Des bains thermaux avec des vues alpines spectaculaires, mais aussi de nombreux sports pour
            toutes les saisons comme le curling, le tennis, les arts martiaux, le football, le vélo, le VTT,
            le ski, la planche à voile et bien plus encore.
            Il y a aussi des attractions touristiques amusantes, ainsi que des promenades de tous niveaux pour vous
            et toute votre famille. Vous allez adorer vivre dans le canton du Valais&nbsp;!
            <Carousel interval={4000} controls={false} indicators={false} >
                <Carousel.Item>
                    <img alt="Bike School & Guide, Verbier" src={require("./pics/leasure/vtt.jpg")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://www.verbierbikepark.ch/" target="_blank" rel="noreferrer">Bike School & Guide, Verbier</a>
                            <br/>
                            +41 27 775 33 63
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={require("./pics/leasure/paragliding.jpg")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'none'}}>
                            <a href="https://www.flybverbier.ch/" target="_blank" rel="noreferrer">FlyVerbier.ch</a>
                            <br/>
                            +41 27 771 68 18
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={require("./pics/leasure/ski.jpg")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://https://verbier4vallees.ch/en" target="_blank" rel="noreferrer">Verbier Ski Ressort</a>
                            <br/>
                            +41 27 775 25 11
                        </div>
                    </Carousel.Caption>

                </Carousel.Item>

                <Carousel.Item>
                    <img  src={require("./pics/leasure/surf2.jpg")}/>
                    <Carousel.Caption>
                        <a href="https://www.alaiabay.ch/" target="_blank" rel="noreferrer">AlaïA Bay</a>
                        <br/>
                        027 322 71 71
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={require("./pics/leasure/paragliding3.jpg")}/>
                    <Carousel.Caption>
                        <a href="https://www.verbier-summits.com/" target="_blank" rel="noreferrer">Verbier Summits</a>
                        <br/>
                        +41 79 710 9132
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={require("./pics/leasure/curling.jpg")}/>
                    <Carousel.Caption>
                        <a href="https://www.curlingmartigny.ch/" target="_blank" rel="noreferrer">Curling Club Martigny</a>
                        <br/>
                        +41 78 625 74 11
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={require("./pics/leasure/realfly.jpg")}/>
                    <Carousel.Caption>
                        <a href="https://www.realfly.ch/" target="_blank" rel="noreferrer">RealFly.ch</a>
                        <br/>
                        027 322 92 92
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item>
                    <img  src={require("./pics/leasure/happyland.JPG")}/>
                    <Carousel.Caption>
                        <a href="https://www.happyland.ch/" target="_blank" rel="noreferrer">Happyland.ch</a>
                        <br/>
                        079 155 35 75
                    </Carousel.Caption>
                </Carousel.Item>

            </Carousel>

            <div className="center">
                Nous ne collectons ni n’envoyons aucune donnée. Nous transmettons simplement des informations publiques
                susceptibles d’être modifiées.
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Fermer
            </Button>
        </Modal.Footer>
    </Modal>


    <Modal show={showModal?.atouts === true} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Dans la vallée</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div>Il existe de nombreuses écoles et institutions de recherche de haut niveau
                qui sont conscientes des enjeux climatiques, résolument tournées vers l’avenir,
                travaillant sur des solutions climatiques, les énergies renouvelables, la capture du carbone,
                l’intelligence artificielle, la reconnaissance faciale, l’IoT, la biologie et bien plus encore.</div>

            <Carousel interval={4000} controls={false} indicators={false} >
                <Carousel.Item>
                    <img alt="Hi School" src={require("./pics/assets/epfl.JPG")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://www.epfl.ch/about/campus/valais-en/epfl-in-valais/" target="_blank" rel="noreferrer">EPFL en Valais</a>
                            <br/>
                            +41 21 695 82 00
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img alt="Hi School" src={require("./pics/assets/epfl_2.JPG")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://www.epfl.ch/about/campus/valais-en/epfl-in-valais/" target="_blank" rel="noreferrer">EPFL en Valais</a>
                            <br/>
                            +41 21 695 82 00
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img alt="Hi School" src={require("./pics/assets/hesso.JPG")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://www.hevs.ch/en/hes-so-valais-wallis/" target="_blank" rel="noreferrer">HES-SO Valais</a>
                            <br/>
                            +41 (0)58 606 85 11
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img alt="Hi School" src={require("./pics/assets/hesso_2.JPG")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://www.hevs.ch/en/hes-so-valais-wallis/" target="_blank" rel="noreferrer">HES-SO Valais</a>
                            <br/>
                            +41 (0)58 606 85 11
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img alt="Hi School" src={require("./pics/assets/idiap.JPG")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://www.idiap.ch/en/" target="_blank" rel="noreferrer">idiap<br/>Institut de recherche</a>
                            <br/>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img className="img-responsive" alt="Prix Créateur" src={require("./pics/assets/logoCreateurs2024_600.jpg")}/>
                    <Carousel.Caption>
                        <div style={{backgroundColor: 'red'}}>
                            <a href="https://www.prixcreateurbcvs.ch/fr/" target="_blank" rel="noreferrer">Valoriser les innovations valaisannes <br/>et récompenser les projets prometteurs</a>
                            <br/>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
            <div className="center">
                Nous ne collectons ni n’envoyons aucune donnée. Nous transmettons simplement des informations publiques susceptibles d’être modifiées.
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Fermer
            </Button>
        </Modal.Footer>
    </Modal>

</React.Fragment>
        )
        }